import styled from 'styled-components'
import { LookButton, iconButtonLook } from 'components/Buttons/look'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  width: 420px;
  background-color: #0000000D;
  padding-top: 8px;
  border-radius: 20px;
  box-shadow: 0px 2px 10px -6px #252525;
  outline: ${({ selected }) => selected ? '1px solid #FFC100' : '1px solid #0000001A'};
  cursor: pointer;
`

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 7px;
  padding: 10px 15px 12px;
  background-color: #FFFFFF;
  border-radius: 0px 0px 20px 20px;
  gap: 8px;
`

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #0000001A;
  margin: 10px 0px;
`

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 7px 18px;
`

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const DetailsToggle = styled(LookButton).attrs(iconButtonLook())`
  align-self: flex-end;
  margin: 0px 10px 7px;
`

export const IconBox = styled.div`
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #0000000D;
  border: 1px solid #0000001A;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: left;
  margin-bottom: 0px;
`

export const Label = styled(InfoText)`
  color: #777777;
  font-size: 14px;
`

export const Title = styled(InfoText)`
  color: #FFC100;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
`

export const MoneyText = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0px;
`
